export default __webpack_public_path__ + "static/logo-3023b0025193534af6063a4cf0c2017c.png";